export default "__VITE_ASSET__ady_pL8i__"